export class SymbolResizingWithInReelWrapper {
    public static _possibleSymbolSizes: number[] = [198, 132, 99, 66, 50];

    public static inputSymbolSize(symbolSize: number[][], isEnhancer: boolean[] = [false, false]): number[] {
        const symbolHeight: number[] = [];
        for (let i: number = 0; i < symbolSize.length; i++) {
            const totalSymbolOnReel: number = symbolSize[i].reduce((a: number, b: number) => a + b);
            symbolHeight.push(SymbolResizingWithInReelWrapper.getSymbolHeights(totalSymbolOnReel, (i == 1 || i == 3), isEnhancer, i));
        }
        return symbolHeight;
    }

    public static getSymbolHeights(totalSymbolOnReel: number, isSpecialSymbolReel: boolean, isEnhancer: boolean[], reelId: number): number {
        const availableHeight: number = isSpecialSymbolReel ? isEnhancer[1 % reelId] ? 198 * 2.5 : 198 * 2 : 198 * 3;
        const eachSymbolHeight: number = availableHeight / totalSymbolOnReel;
        return eachSymbolHeight;
    }


    public static getFireFrameSymbolSizeInGame(fFsymbolSize: number[][], isEnhancer: boolean[]): number[][] {
        fFsymbolSize[1][2] = Number(isEnhancer[0]);
        fFsymbolSize[3][2] = Number(isEnhancer[1]);
        return fFsymbolSize;
    }
}